import React, { useMemo } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import MoreMenu from "@/components/MoreMenu";

const useNissanDealersTableColumns = ({ onMenuItemClick }) =>
  useMemo(
    () => [
      {
        title: "Code",
        dataIndex: "code",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Name",
        dataIndex: "name",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Exec Manager",
        dataIndex: "manager",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Address",
        dataIndex: "addressLine1",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "City",
        dataIndex: "city",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "State",
        dataIndex: "state",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Zip",
        dataIndex: "zipCode",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Region",
        dataIndex: "region",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Phone",
        dataIndex: "phoneNumber",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Fax",
        dataIndex: "fax",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Delivery Email Recipients",
        dataIndex: "emails",
        render: text => {
          const emails = text?.split(";");
          const counter = emails?.length;
          return (
            <Tooltip
              color="#fff"
              title={emails.map(email => (
                <>
                  <span key={email}>{email}</span>
                  <hr />
                </>
              ))}
            >
              <span>{counter}</span>
            </Tooltip>
          );
        },
      },
      {
        title: "",
        key: "action",
        dataIndex: "moreMenu",
        render: (_, record) => (
          <span>
            <MoreMenu
              onItemClick={key => onMenuItemClick(key, record)}
              items={[
                {
                  key: "edit",
                  icon: <EditOutlined />,
                  label: "Edit",
                  authority: "NissanService.Dealers.Edit",
                },
                {
                  key: "delete",
                  icon: <DeleteOutlined />,
                  label: "Delete",
                  authority: "NissanService.Dealers.Delete",
                },
              ]}
            />
          </span>
        ),
      },
    ],
    [onMenuItemClick],
  );

export default useNissanDealersTableColumns;
